import React from 'react';
import { useHoverTilt, useMagneticEffect, useFloatingAnimation } from '../hooks/useMicroInteractions';
import './InteractiveCard.css';

const InteractiveCard = ({ 
  children, 
  variant = 'default',
  tilt = false,
  magnetic = false,
  floating = false,
  glow = false,
  className = '',
  contentClassName = '',
  onClick,
  ...props 
}) => {
  // Mycket subtila effekter som matchar övriga komponenter
  const { elementRef: tiltRef, transform: tiltTransform } = useHoverTilt(tilt ? 2 : 0);
  const { elementRef: magneticRef, transform: magneticTransform } = useMagneticEffect(
    magnetic ? 5 : 0,
    magnetic ? 300 : 0
  );
  const { transform: floatingTransform } = useFloatingAnimation(
    floating ? 4000 : 0, 
    floating ? 3 : 0
  );

  // Combine refs
  const setRefs = (element) => {
    if (tiltRef && tiltRef.current !== undefined) tiltRef.current = element;
    if (magneticRef && magneticRef.current !== undefined) magneticRef.current = element;
  };

  // Mycket subtil transform-kombination
  const combinedTransform = [
    tiltTransform && tiltTransform !== 'perspective(1000px) rotateX(0deg) rotateY(0deg)' ? tiltTransform : '',
    magneticTransform && magneticTransform !== 'translate3d(0px, 0px, 0)' ? magneticTransform : '',
    floatingTransform && floatingTransform !== 'translateY(0px)' ? floatingTransform : ''
  ].filter(Boolean).join(' ') || undefined;

  const cardClasses = `
    interactive-card
    interactive-card--${variant}
    ${tilt ? 'interactive-card--tilt' : ''}
    ${magnetic ? 'interactive-card--magnetic' : ''}
    ${floating ? 'interactive-card--floating' : ''}
    ${glow ? 'interactive-card--glow' : ''}
    ${onClick ? 'interactive-card--clickable' : ''}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div
      ref={setRefs}
      className={cardClasses}
      style={combinedTransform ? { transform: combinedTransform } : {}}
      onClick={onClick}
      {...props}
    >
      <div className="interactive-card__background" />
      <div className="interactive-card__border" />
      {glow && <div className="interactive-card__glow" />}
      <div className={`interactive-card__content ${contentClassName}`}>
        {children}
      </div>
      <div className="interactive-card__overlay" />
    </div>
  );
};

// Specialized card variants
export const GlassCard = (props) => (
  <InteractiveCard variant="glass" glow={true} {...props} />
);

export const NeumorphicCard = (props) => (
  <InteractiveCard variant="neumorphic" {...props} />
);

export const GradientCard = (props) => (
  <InteractiveCard variant="gradient" tilt={true} glow={true} {...props} />
);

export const PackageCard = (props) => (
  <InteractiveCard variant="package" tilt={true} magnetic={true} {...props} />
);

export const TestimonialCard = (props) => (
  <InteractiveCard variant="testimonial" floating={true} {...props} />
);

export default InteractiveCard;
